/**
 * 通用的飞入 mixins
 * @desc 主要应用于入场飞入的元素
 * @param {string} name - 组件名称
 * @param {Array} animateScenesData - 动画组件列表
 */
export default {
  data() {
    return {
      animateScenes: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      /**
       * Add animate scene
       */
      this.animateScenes = this.animateScenesData.map((el) => {
        const title = typeof el === 'string' ? el : el.title
        const scene = this.$scrollmagic
          .scene({
            triggerElement: `#js-${this.name}-${title}`,
            triggerHook: 1,
          })
          .setClassToggle(
            `#js-${this.name}-${title} ${el.element || '.app-fadeInUp'}`,
            el.classes || 'app-fadeInUp-active'
          )

        // indicator
        process.env.NODE_ENV === 'development' &&
          scene.addIndicators({ name: `${this.name} ${title} animate` })

        this.$scrollmagic.addScene(scene)

        return scene
      })
    })
  },
  destroyed() {
    /**
     * Destroy animate scene
     */
    if (this.animateScenes.length > 0) {
      this.animateScenes.forEach((el) => {
        el.destroy(true)
      })
    }
  },
}
